import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import React from "react";
import { NavigationProvider } from "./hooks/NavigationContext";
import { SelfServeContextProvider } from "./hooks/SelfServeContext";
import { useExistedBrandOrderEffect } from "./hooks/useExistedBrandOrderEffect";
import { SelfServeRouter } from "./SelfServeRouter";
export var SelfServeBase = function SelfServeBase() {
  return /*#__PURE__*/React.createElement(SelfServeContextProvider, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NavigationBase, null)));
};
var NavigationBase = function NavigationBase() {
  var queryState = useExistedBrandOrderEffect();
  if (queryState.isLoading) {
    return /*#__PURE__*/React.createElement(NavigationProvider, null, /*#__PURE__*/React.createElement(Row, {
      align: "center",
      justify: "center"
    }, /*#__PURE__*/React.createElement(LoadingSpinner, {
      size: "large"
    })));
  }
  return /*#__PURE__*/React.createElement(NavigationProvider, null, /*#__PURE__*/React.createElement(SelfServeRouter, _objectSpread({}, queryState)));
};